import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminRunPanel } from '../components/AdminRunPanel';
import { SESSION_TOKEN } from '../lib/session';

// Cross-org run lookup (`/admin/runs/:run_id`).
//
// TOP-LEVEL, not org-scoped, and that is the whole mechanism. On `/admin/*`
// `orgFromPath` resolves nothing, so `apiFetch` sends no `X-Dz-Account` header —
// which is what lets the server resolve the run's OWNER itself. Opening the same
// run under `/org/<some-login>/fleet/runs/<id>` is precisely the request that
// failed in prod: the header fenced it to the org in the URL and the run belonged
// to another tenant.
//
// Deliberately small. It answers the operator's first two questions — whose run
// is this, and where did it get to — and the rich timeline is a separate slice.
// The link out is the OWNING ORG's own run page, offered only when the operator
// actually holds a membership there: for the accounts with no `developerz-ai`
// owner among their members (2 of 7 in prod, which is why this page exists) that
// page 404s, and a link that fails for exactly the case the page was built for
// would be worse than none.
//
// Every read here appends a `platform_audit_events` row before the server
// answers, and the subtitle says so — we tell customers we can and will look at
// their runs, and a page that quietly did it would make that disclosure a
// formality.

// Thin: <AdminGate/> keeps the panel (and its run read) behind the staff wall,
// so a walled session asks the server nothing about the run. `token` is
// injectable for tests; the router mounts with no props.

export function AdminRun(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token === undefined ? SESSION_TOKEN : props.token;
  return (
    <AdminGate token={token}>
      <AdminRunPanel token={token} />
    </AdminGate>
  );
}
